module.exports = __webpack_public_path__ + "img/0.927554f1.png";